module.exports = __webpack_public_path__ + "outline-icons.82f60bd0b94a1ed68b1e.svg";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/semantic/themes/default/assets/fonts/outline-icons.svg
// module id = ../../../../../src/assets/semantic/themes/default/assets/fonts/outline-icons.svg
// module chunks = styles